import React from "react";

import GuillotineGlass from "../components/GuillotineGlass";
import FacingText from "../components/FacingText";

// U şeklinde alt profil
const BottomProfile = ({ width, depth, height, position, color }) => {
    return (
        <group position={position}>
            {/* Alt taban */}
            <mesh position={[0, 0.01 / 2, 0]}>
                <boxGeometry args={[width, height, depth]} />
                <meshStandardMaterial color={color} />
            </mesh>
        </group>
    );
};


const GuillotinePanel = ({ isExporting, section, width, height, config, index, position, isOpenTrigger, rotation, almColor, glassColor, glassColor2 }) => {

    const sideThickness = 0.18;
    const topBoxHeight = 0.06;
    const bottomBoxHeight = 0.04;
    const w = width;
    const h = height;
    const panelCount = section.panels?.length || 1;
    const frameThickness = 0.03;
    const netPanelHeight = (h - topBoxHeight - bottomBoxHeight - (panelCount - 1) * frameThickness) / panelCount;
    const leftBox = section.left_box;
    const rightBox = section.right_box;
    const pozLabel = `P${index + 1}`;

    const channelWidth = 0.02;
    const channelDepth = 0.04;
    const channelHeight = h;

    return (
        <group key={index} position={position} rotation={rotation} >
            {/* Sol kutu profil */}
            {leftBox && (
                <mesh position={[-w / 2 - sideThickness / 4, 0.06, 0]}>
                    <boxGeometry args={[sideThickness, h + 0.12, sideThickness]} />
                    <meshStandardMaterial color={"#888"} />
                </mesh>
            )}

            {/* Sağ kutu profil */}
            {rightBox && (//section.right_box
                <mesh position={[w / 2 + sideThickness / 4, 0.06, 0]}>
                    <boxGeometry args={[sideThickness, h + 0.12, sideThickness]} />
                    <meshStandardMaterial color={"#888"} />
                </mesh>
            )}

            {/* Sol profil */}
            <mesh position={[-w / 2 + sideThickness / 2, 0, 0]}>
                <boxGeometry args={[sideThickness / 2, h, sideThickness]} />
                <meshStandardMaterial color={almColor} />
            </mesh>

            {/* Sol kanal 1*/}
            <mesh position={[-w / 2 + sideThickness / 2 + 0.037, 0, -sideThickness / 4]}>
                <boxGeometry args={[channelWidth, channelHeight, channelDepth]} />
                <meshStandardMaterial color={"#333"} />
            </mesh>

            {/* Sol kanal 2*/}
            {panelCount > 2 && (<mesh position={[-w / 2 + sideThickness / 2 + 0.037, -h / ((panelCount - 1) * panelCount), -sideThickness / 4 + channelWidth * 2]}>
                <boxGeometry args={[channelWidth, channelHeight / panelCount * (panelCount - 1) - (panelCount == 3 ? 0.08 : 0.28), channelDepth]} />
                <meshStandardMaterial color={"#333"} />
            </mesh>)}

            {/* Sol kanal 3*/}
            {panelCount > 3 && (<mesh position={[-w / 2 + sideThickness / 2 + 0.037, -h / 4, -sideThickness / 4 + channelWidth * 3.5]}>
                <boxGeometry args={[channelWidth, channelHeight / 2 - 0.08, channelDepth]} />
                <meshStandardMaterial color={"#333"} />
            </mesh>)}

            {/* Sağ profil */}
            <mesh position={[w / 2 - sideThickness / 2, 0, 0]}>
                <boxGeometry args={[sideThickness / 2, h, sideThickness]} />
                <meshStandardMaterial color={almColor} />
            </mesh>

            {/* Sağ kanal 1*/}
            <mesh position={[w / 2 - sideThickness / 2 - 0.037, 0, -sideThickness / 4]}>
                <boxGeometry args={[channelWidth, channelHeight, channelDepth]} />
                <meshStandardMaterial color={"#333"} />
            </mesh>

            {/* Sağ kanal 2*/}
            {panelCount > 2 && (<mesh position={[w / 2 - sideThickness / 2 - 0.037, -h / ((panelCount - 1) * panelCount), -sideThickness / 4 + channelWidth * 2]}>
                <boxGeometry args={[channelWidth, channelHeight / panelCount * (panelCount - 1) - (panelCount == 3 ? 0.08 : 0.28), channelDepth]} />
                <meshStandardMaterial color={"#333"} />
            </mesh>)}

            {/* Sağ kanal 3*/}
            {panelCount > 3 && (<mesh position={[w / 2 - sideThickness / 2 - 0.037, -h / 4, -sideThickness / 4 + channelWidth * 3.5]}>
                <boxGeometry args={[channelWidth, channelHeight / 2 - 0.08, channelDepth]} />
                <meshStandardMaterial color={"#333"} />
            </mesh>)}

            {/* Üst kutu */}
            <mesh position={[0, h / 2 + topBoxHeight / 2, 0]}>
                <boxGeometry args={[w - sideThickness / 2, topBoxHeight + 0.12, sideThickness]} />
                <meshStandardMaterial color={almColor} />
            </mesh>

            {/* Üst kutu - vidalar sol */}
            {[0.04, -0.04].map((y) =>
                [0.04, -0.04].map((z, i) => (
                    <mesh
                        key={`screw-left-${i}-${y}`}
                        position={[-w / 2 - 0.0025 + sideThickness / 4, h / 2 + topBoxHeight / 2 + y, z]}
                    >
                        <cylinderGeometry args={[0.003, 0.003, 0.004, 12]} />
                        <meshStandardMaterial color={"#222"} />
                    </mesh>
                ))
            )}

            {/* Üst kutu - vidalar sağ */}
            {[0.04, -0.04].map((y) =>
                [0.04, -0.04].map((z, i) => (
                    <mesh
                        key={`screw-right-${i}-${y}`}
                        position={[w / 2 + 0.0025 - sideThickness / 4, h / 2 + topBoxHeight / 2 + y, z]}
                    >
                        <cylinderGeometry args={[0.005, 0.005, 0.005, 12]} />
                        <meshStandardMaterial color={"#222"} />
                    </mesh>
                ))
            )}

            {/* Alt profil */}
            <BottomProfile
                width={w - sideThickness}
                depth={sideThickness}
                height={bottomBoxHeight}
                position={[0, -h / 2 + 0.015, 0]}
                color={almColor}
            />

            {/* Camlar */}
            {Array.from({ length: panelCount }).map((_, i) => (
                <GuillotineGlass
                    key={i}
                    index={i}
                    isOpen={isOpenTrigger}
                    glassWidth={w - 1.5 * sideThickness}
                    netPanelHeight={netPanelHeight}
                    frameThickness={frameThickness}
                    topBoxHeight={topBoxHeight}
                    hegiht={h}
                    config={config}
                    panelSize={section.panels.length}
                    rotation={rotation}
                    almColor={almColor}
                    glassColor={glassColor}
                    glassColor2={glassColor2}
                    isExporting={isExporting}
                />
            ))}

            {/* POZ ve ÖLÇÜ BİLGİSİ */}
            {!isExporting && (<FacingText
                position={[-w / 2, -h / 2 - 0.1, 0]}
                fontSize={0.1}
                color="black"
            >{pozLabel}</FacingText>)}

            {!isExporting && (<FacingText
                position={[-w / 2, -h / 2 - 0.2, 0]}
                fontSize={0.08}
                color="black"
            >{section.size.width}x{section.size.height}</FacingText>
            )};
        </group>
    );
};

export default GuillotinePanel;